import { render, staticRenderFns } from "./vFoot.vue?vue&type=template&id=37ad2be2&scoped=true"
import script from "./vFoot.vue?vue&type=script&lang=js"
export * from "./vFoot.vue?vue&type=script&lang=js"
import style0 from "./vFoot.vue?vue&type=style&index=0&id=37ad2be2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ad2be2",
  null
  
)

export default component.exports